import React from 'react';
import MuiGrid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import NextLink from 'next/link';
// import FacebookIcon from '../../shared/icons/Facebook';
// import YoutubeIcon from '../../shared/icons/Youtube';
// import TwitterIcon from '../../shared/icons/Twitter';
// import useForceUpdate from '../../utils/useForceUpdate';

const useStyles = makeStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    padding: theme.spacing(2, 1.5),
  },
  divider: {
    margin: theme.spacing(0, 1),
  },
  signAgainButton: {
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.grey[500],
    },
  },
}));

const Sticker = ({ src, ...props }) => {
  return (
    <Box
      component="a"
      target="_blank"
      ml={0.5}
      mr={0.5}
      rel="noopener noreferer"
      {...props}
    >
      <Box component="img" height="auto" width={65} src={src} />
    </Box>
  );
};
const linkContext = process.env.NODE_ENV === 'production' ? '/' : '/depv/';
const Footer = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <footer className={classes.root}>
        <MuiGrid container spacing={3}>
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center" height="100%">
              <NextLink passHref href={`${linkContext}anmelden`}>
                <Typography component="a" color="primary" variant="subtitle1">
                  Login
                </Typography>
              </NextLink>
              <Divider orientation="vertical" className={classes.divider} />

              <NextLink
                passHref
                href={`${linkContext}[...pageId]`}
                as={`${linkContext}ueber-den-depv`}
              >
                <Typography component="a" color="primary" variant="subtitle1">
                  Über den DEPV
                </Typography>
              </NextLink>
              <Divider orientation="vertical" className={classes.divider} />

              <NextLink
                passHref
                href={`${linkContext}[...pageId]`}
                as={`${linkContext}mitglied-werden`}
              >
                <Typography component="a" color="primary" variant="subtitle1">
                  Mitglied werden
                </Typography>
              </NextLink>
            </Box>
          </MuiGrid>
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center">
              <Typography variant="body2" color="textSecondary">
                Besuchen Sie auch
              </Typography>
            </Box>
          </MuiGrid>
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center">
              <Sticker
                href="http://www.enplus-pellets.de"
                src="/images/ENplus_Logo.svg"
              />
              <Sticker
                href="http://www.enplus-hackschnitzel.de"
                src="/images/ENplus_Logo_Hackschnitzel.svg"
              />
              <Sticker
                href="http://www.enplus-briketts.de"
                src="/images/ENplus_Logo_Holzbriketts.svg"
              />
              <Sticker
                href="https://depi.de/pelletfachbetriebe-und-ofenstudios"
                src="/images/Logo_Fachstudio.svg"
              />
              <Sticker
                href="https://depi.de/pelletfachbetriebe-und-ofenstudios"
                src="/images/Logo_Pelletfachbetrieb.svg"
              />
            </Box>
          </MuiGrid>
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center" height="100%">
              <NextLink passHref href={`${linkContext}kontakt`}>
                <Typography component="a" color="primary" variant="subtitle1">
                  Kontakt
                </Typography>
              </NextLink>
              <Divider orientation="vertical" className={classes.divider} />

              <NextLink
                passHref
                href={`${linkContext}[...pageId]`}
                as={`${linkContext}impressum`}
              >
                <Typography component="a" color="primary" variant="subtitle1">
                  Impressum
                </Typography>
              </NextLink>
              <Divider orientation="vertical" className={classes.divider} />

              <NextLink
                passHref
                href={`${linkContext}[...pageId]`}
                as={`${linkContext}datenschutz`}
              >
                <Typography component="a" color="primary" variant="subtitle1">
                  Datenschutz
                </Typography>
              </NextLink>
              <Divider orientation="vertical" className={classes.divider} />

              <NextLink
                passHref
                href={`${linkContext}[...pageId]`}
                as={`${linkContext}stellenmarkt`}
              >
                <Typography component="a" color="primary" variant="subtitle1">
                  Stellenmarkt
                </Typography>
              </NextLink>
            </Box>
          </MuiGrid>
          <MuiGrid item xs={12}>
            <Box display="flex" justifyContent="center">
              <Typography variant="caption" color="textSecondary">
                Copyright © 2008-{new Date().getFullYear()} DEPV. Alle Rechte
                vorbehalten.
              </Typography>
            </Box>
          </MuiGrid>
        </MuiGrid>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
